import { Component, Input, OnInit, ViewChild, EventEmitter, Output, signal, viewChild, ElementRef } from '@angular/core';

import { PipeModule } from '@app/pipe/pipe.module';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MediaService } from '@app/services/media.service';
@Component({
    selector: 'imageslider',
    templateUrl: './imageslider.component.html',
    styleUrls: ['./imageslider.component.scss'],
    imports: [
        CommonModule,
        PipeModule,
        MatIconModule
    ]
})
export class ImagesliderComponent implements OnInit {
    @Input()
    set data(v: string[]) {
        this._data.set(v);
        this.init();
    }

    get data() {
        return this._data();
    }
    @Input() current: number = 0;
    @Input() nocache: boolean = false;
    @Input() showImages: boolean = true;
    @Input() radiustopleft: boolean = false;
    @Input() radiustopright: boolean = false;
    @Input() radiusbottomleft: boolean = false;
    @Input() radiusbottomright: boolean = false;
    @Input() showcounter: boolean = true;
    @Output() clickOnImg = new EventEmitter<number>();
    // @ViewChild('imageslidercontent') imageslidercontent: { nativeElement: { offsetWidth: number; scrollLeft: number; }; };
    imageslidercontent = viewChild<ElementRef<HTMLDivElement>>('imageslidercontent');

    currentimgposition = signal<number>(0);
    _current = signal<number>(0);

    _data = signal<string[]>([]);

    constructor(protected mediaService: MediaService) {
    }

    ngOnInit(): void {
        this.init();
    }

    init() {
        if (this._data()?.length > 0) {
            for (let i = 0; i < this._data()?.length; i++) {
                this._data()[i] = this._data()?.[i]?.replace(/http:/g, 'https:');
            }
        } else {
            this._data.set(['../../assets/images/empty.jpg']);
        }

        this._current.set(this.current);
    }

    handelError(index) {
        if (this._data()?.length > index) {
            this._data().splice(index, 1);
        }
    }

    async previus(ev) {
        ev.stopPropagation();
        if (this.imageslidercontent() && this.imageslidercontent()?.nativeElement) {
            if (this._current() > 0) {
                this._current.set(this._current() - 1);
                const scrollPos = this.imageslidercontent().nativeElement.offsetWidth * this._current();
                this.imageslidercontent().nativeElement.scrollLeft = scrollPos;
            }
        }
    }

    async next(ev) {
        ev.stopPropagation();
        if (this.imageslidercontent() && this.imageslidercontent()?.nativeElement) {
            if (this._current() < this._data().length - 1) {
                this._current.set(this._current() + 1);
                const scrollPos = this.imageslidercontent()?.nativeElement.offsetWidth * this._current();
                this.imageslidercontent().nativeElement.scrollLeft = scrollPos;
            }
        }
    }

    async scrolling() {
        if (this.imageslidercontent() && this.imageslidercontent().nativeElement) {
            const wd = this.imageslidercontent().nativeElement.offsetWidth;
            const sc = this.imageslidercontent().nativeElement.scrollLeft;
            if (wd > 0) {
                this._current.set(Math.round(sc / wd));
            }

            this.currentimgposition.set(this._current());
        }
    }

    async sendClick() {
        this.clickOnImg.emit(this._current());
    }
}
